var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0a1 1 0 01.993.883L17 1v1h5c1.052 0 1.918.817 1.995 1.85L24 4v18a2.003 2.003 0 01-1.851 1.995L22 24H2a2.002 2.002 0 01-1.994-1.85L0 22V4c0-1.053.817-1.918 1.851-1.995L2.001 2h5V1A1 1 0 018.992.883L9 1v1h6V1a1 1 0 011-1zM7 4H2v18h19.997L22 4h-5v1a1 1 0 01-1.993.117L15 5V4H9v1a1 1 0 01-1.993.117L7 5V4zm12 10a1 1 0 01.993.883L20 15v2a1 1 0 01-.883.993L19 18h-2a1 1 0 01-.993-.883L16 17v-2a1 1 0 01.883-.993L17 14h2zM7 14a1 1 0 01.993.883L8 15v2a1 1 0 01-.883.993L7 18H5a1 1 0 01-.993-.883L4 17v-2a1 1 0 01.883-.993L5 14h2zm6 0a1 1 0 01.993.883L14 15v2a1 1 0 01-.883.993L13 18h-2a1 1 0 01-.993-.883L10 17v-2a1 1 0 01.883-.993L11 14h2zm6-6a1 1 0 01.993.883L20 9v2a1 1 0 01-.883.993L19 12h-2a1 1 0 01-.993-.883L16 11V9a1 1 0 01.883-.993L17 8h2zM7 8a1 1 0 01.993.883L8 9v2a1 1 0 01-.883.993L7 12H5a1 1 0 01-.993-.883L4 11V9a1 1 0 01.883-.993L5 8h2zm6 0a1 1 0 01.993.883L14 9v2a1 1 0 01-.883.993L13 12h-2a1 1 0 01-.993-.883L10 11V9a1 1 0 01.883-.993L11 8h2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconCalendar;